import { ObservableMap } from "mobx";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapGetOrCreate = <M extends Map<any, any> | ObservableMap<any,any>>(map: M, key: Parameters<M["get"]>[0], create: () => NonNullable<ReturnType<M["get"]>>): NonNullable<ReturnType<M["get"]>> => {
	let value = map.get(key);
	if (value == null) {
		value = create();
		map.set(key, value);
	}
	return value;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapGetOrCreateAsync = async <M extends Map<any, any>>(
	map: M,
	key: Parameters<M["get"]>[0],
	create: () => Promise<NonNullable<ReturnType<M["get"]>>>
): Promise<NonNullable<ReturnType<M["get"]>>> => {
	let value = map.get(key);
	if (value == null) {
		value = await create();
		map.set(key, value);
	}
	return value;
}

